module.exports = __webpack_public_path__ + "img/jinshukuai04-430.9c672657.jpg";